export default "__VITE_ASSET__DQdlpF$Q__"